import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { RootState } from '../../../../store';
import './../help-center.css';

interface IPlaceCrosOrderWidgetProps {
    onClose: () => void;
}

export const PlaceCrosOrderWidget = ({
    onClose,
}: IPlaceCrosOrderWidgetProps) => {
    return (
        <>
            <div className="box-collage-next">
                <button
                    className="boxes-btn"
                    onClick={() => {
                        onClose();
                    }}
                >
                    &lt;
                    <FormattedMessage id="Back" defaultMessage="Back" />
                </button>
                <h2>
                    <FormattedMessage
                        id="How_do_I_place_a_CROS_order"
                        defaultMessage="How do I place a CROS order?"
                    />
                </h2>
                <div className="row">
                    <div className="col-sm-12">
                        <h3>
                            <FormattedMessage
                                id="Step_by_step_guide"
                                defaultMessage="Step by Step Guide"
                            />
                        </h3>
                        <ol className="ordered-list">
                            <li>
                                <FormattedMessage
                                    id="Cross_Step_1"
                                    defaultMessage="Step 1. Select Shop Hearing Aids under Quick Links on the home page to purchase hearing aids. You can also start an order under the Shop tab."
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="Cross_Step_2"
                                    defaultMessage="Step 2. Select Show Filters to choose the device you are looking for."
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="Cross_Step_3"
                                    defaultMessage="Step 3. Start by selecting Wireless CROS System."
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="Cross_Step_4"
                                    defaultMessage="Step 4. Select the CROS System you are looking for from the displayed options."
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="Cross_Step_5"
                                    defaultMessage="Step 5. Once you are in the order form, select the case color and always select yes under “Is this for a patient?”. Everything with a red star next to it is a required field, fill out those sections."
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="Cross_Step_6"
                                    defaultMessage="Step 6. Under Fit Options select Ear and Receiver Fit options. If you chose right or left ear only, you will be prompted to input the serial number of the device the CROS will be paired with."
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="Cross_Step_7"
                                    defaultMessage="Step 7. Next, fill out the Product Options section. If you select an earmold or a custom cased / AP, you will be prompted to fill out the Send Impressions and Audiogram sections, as well as the earmold options."
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="Cross_Step_8"
                                    defaultMessage="Step 8. Add any additional accessories or common supplies to the order, as needed."
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="Cross_Step_9"
                                    defaultMessage="Step 9. Next, under the warranty section, add additional warranty, if needed."
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="Cross_Step_10"
                                    defaultMessage="Step 10. Next, select Add to Cart and Proceed to Checkout."
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="Cross_Step_11"
                                    defaultMessage="Step 11. In the checkout confirm Bill to, Ship to, Purchase Order Number (if it applies), Rush Service (if needed) and Shipping Method."
                                />
                                <br />
                                <br />
                                <FormattedMessage
                                    id="Cross_Step_11_Note"
                                    defaultMessage="Note: If you are ordering under a third-party billing account, this is where you change the Bill to account and add the PO number (If third party Bill to account is not under the Bill to account dropdown, call Customer Service Prosite Team to get it added)."
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="Cross_Step_12"
                                    defaultMessage="Step 12. Review order and select Place Order. A confirmation email will be sent to the email address of the user that is logged in."
                                />
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {};
};

const mapDispatchToProps = {};

const placeCrosOrderWidgetContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PlaceCrosOrderWidget);

export default placeCrosOrderWidgetContainer;
